import React, { useEffect, useState } from "react";
import {
  Datagrid,
  Filter,
  FunctionField,
  ListProps,
  ReferenceField,
  ReferenceInput,
  SearchInput,
  SelectInput,
  TextField,
  useDataProvider,
} from "react-admin";
import { SchoolIdSelected } from "utils/tools";
import { notRenewedCcaStudentStatusList } from "./const";
import CustomPagination from "components/CustomPagination";
import CustomBooleanField from "components/CustomBooleanField";
import StatusField from "components/StatusField";
import UpdatedByField from "components/UpdatedByField";
import ParentLinkField from "./components/ParentLinkField";
import ConfirmCcaStudentRenewalButton from "./components/ConfirmCcaStudentRenewalButton";
import ListWrapper from "../../components/ListWrapper";
import ActionsMenu from "../../components/ActionsMenu";

const StudentFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <ReferenceInput
      label="CCA Academic Year"
      source="ccaAcademicYearId"
      reference="ccaAcademicYears"
      filter={{
        SchoolId: Number(SchoolIdSelected()),
      }}
      alwaysOn
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
    <SelectInput
      label="Status"
      source="Status"
      choices={notRenewedCcaStudentStatusList}
      alwaysOn
    />
  </Filter>
);

const breadcrumb = [
  { link: "/ccaStudentRenewals", title: "CCA Student Renewals" },
];

const DueRenewalStudentList = (props: ListProps) => {
  const schoolId = Number(SchoolIdSelected());
  const provider = useDataProvider();
  const [school, setSchool] = useState<ISchool>();

  useEffect(() => {
    if (schoolId) {
      provider.getOne("schools", { id: schoolId }).then(({ data }) => {
        setSchool(data as ISchool);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolId]);

  return (
    <>
      <ListWrapper
        breadcrumb={breadcrumb}
        headerTitle="CCA Student Renewals"
        denseMode
        exporter={false}
        filters={<StudentFilter />}
        filter={{
          SchoolId: Number(SchoolIdSelected()),
        }}
        perPage={50}
        sort={{ field: "CreatedAt", order: "DESC" }}
        bulkActionButtons={false}
        {...props}
        hasCreate={false}
        pagination={<CustomPagination />}
      >
        <Datagrid>
          <TextField source="student.id" label="Student Id" />
          <FunctionField
            label="Name"
            render={(record: any) =>
              `${record.student?.firstName} ${record.student?.lastName}`
            }
          />
          <FunctionField
            label="CCA Academic Year Info"
            render={(record: any) => `${record.currentCcaAcademicYear?.name}`}
          />
          <ReferenceField
            label="Parent Info"
            source="student.id"
            reference="students"
            link={false}
          >
            <FunctionField
              render={(record: any) => <ParentLinkField record={record} />}
            />
          </ReferenceField>
          <CustomBooleanField
            source="isMaxLevel"
            textForTrueValue="Yes"
            textForFalseValue="No"
          />
          <StatusField source="status" />
          <FunctionField
            label="Updated By"
            render={(record: any) => (
              <>
                {record.updatedBy === null ? (
                  "-"
                ) : (
                  <UpdatedByField data={record.updatedBy} />
                )}
              </>
            )}
          />
          <FunctionField
            label="Action"
            render={(record: any) => (
              <ActionsMenu
                render={[
                  record.status === "pending" && (
                    <ConfirmCcaStudentRenewalButton
                      id={record.id}
                      studentId={record.student.id}
                      ccaAcademicYearId={record.currentCcaAcademicYear.id}
                      school={school}
                      history={props.history}
                    />
                  ),
                ]}
              />
            )}
          />
        </Datagrid>
      </ListWrapper>
    </>
  );
};

export default DueRenewalStudentList;
